module.exports = __webpack_public_path__ + "signup_step_lollipop_2.aeb7eb5ced99c32de6ca399873a1fa0e.jpg";